export default [
  {
    name: 'documents',
    path: '/documents',
    component: () => import('@/pages/documents/Documents.vue'),
  },
  {
    name: 'documents/limit-transaction',
    path: '/documents/limit-transaction',
    component: () => import('@/pages/documents/DocumentLimitTransaction.vue'),
  },
  {
    name: 'documents/income-certification',
    path: '/documents/income-certification',
    component: () => import('@/pages/documents/IncomeCertification.vue'),
  },
  {
    name: 'documents/income-certification/confirm',
    path: '/documents/income-certification/confirm',
    component: () => import('@/pages/documents/IncomeCertificationConfirm.vue'),
  },
]
